import { formatAmountWithCurrency } from "../global_vars";
import { formatDecimalWithComma } from "./decimalFormat";

/** Signed amount: expenses negative, payments positive. */
export function cashTransactionSignedAmount(transaction) {
  if (!transaction) return 0;
  if (transaction.kind === "E") {
    return -(Number(transaction.amountexp) || 0);
  }
  if (transaction.kind === "P") {
    return Number(transaction.amountpay) || 0;
  }
  const fallback = Number(transaction.amountexp || transaction.amountpay) || 0;
  return fallback;
}

function transactionCurrency(transaction) {
  return String(transaction?.country?.currency || transaction?.currency || "EUR").toUpperCase();
}

/**
 * Net accounting total converted to EUR.
 * USD amounts use global usd_eur_rate (1 USD = rate EUR).
 */
export function calculateAccountingTotal(transactions, usdEurRate = null) {
  const rate = usdEurRate != null && usdEurRate !== "" ? Number(usdEurRate) : null;
  let totalEur = 0;
  let skippedUsdCount = 0;
  let usdCount = 0;

  (transactions || []).forEach((transaction) => {
    const signed = cashTransactionSignedAmount(transaction);
    const currency = transactionCurrency(transaction);

    if (currency === "EUR") {
      totalEur += signed;
      return;
    }

    if (currency === "USD") {
      usdCount += 1;
      if (rate && rate > 0) {
        totalEur += signed * rate;
      } else {
        skippedUsdCount += 1;
      }
      return;
    }

    totalEur += signed;
  });

  return {
    totalEur,
    rate: rate && rate > 0 ? rate : null,
    skippedUsdCount,
    usdCount,
    transactionCount: (transactions || []).length,
  };
}

export function formatAccountingTotalDisplay(totalEur) {
  const sign = totalEur > 0 ? "+" : totalEur < 0 ? "−" : "";
  const formatted = formatAmountWithCurrency(Math.abs(totalEur), "EUR");
  return `${sign}${formatted}`;
}

export function formatCurrencyRateDisplay(rate) {
  if (rate == null || rate === "") return "Not set";
  return `1 USD = ${formatDecimalWithComma(rate)} EUR`;
}
